import { useCallback } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type {
  ClickChooseMyLeague,
  ClickEnterPro,
  ClickGetStarted,
  ClickLeague,
} from '@sorare/core/src/protos/events/platform/web/events';

type ProOnboardingEvents = {
  'Click Enter Pro': ClickEnterPro;
  'Click Choose My League': ClickChooseMyLeague;
  'Click League': ClickLeague;
  'Click Get Started': ClickGetStarted;
};

type ExtraProps<K extends keyof ProOnboardingEvents> = Omit<
  ProOnboardingEvents[K],
  'sport' | 'funnel'
>;

export const useProOnboardingEvents = () => {
  const track = useEvents();
  const { sport } = useSportContext();
  const { footballUserProfile } = useCurrentUserContext();

  const funnel = footballUserProfile?.forceToProOnboarding
    ? 'pro_onboarding'
    : 'arcade';

  return useCallback(
    <K extends keyof ProOnboardingEvents>(
      event: K,
      ...rest: keyof ExtraProps<K> extends never ? [] : [ExtraProps<K>]
    ) => {
      // @ts-expect-error the generic event key can't be correlated with its payload type
      track(event, { sport, funnel, ...rest[0] });
    },
    [track, sport, funnel]
  );
};
